// Hook dodania usługi do pozycji oferty –
// POST /sales-crm/clients/:cid/offers/:oid/positions/:pid/services

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type {
  OfferServicePriceType,
  ISalesCrmOfferService
} from 'api/endpoints/useGetSalesCrmOfferServices';

export interface IPostSalesCrmOfferServicePayload {
  serviceId: number | null;
  name: string | null;
  priceNet: number;
  priceGross: number | null;
  taxPercent: number;
  priceType: OfferServicePriceType;
}

type IResponse = ICommandResponseSuccess & Partial<ISalesCrmOfferService>;

const postSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPostSalesCrmOfferServicePayload
): Promise<IResponse> =>
  axios.post(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/services`,
    payload
  );

export const usePostSalesCrmOfferService = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmOfferServicePayload>
) =>
  useMutation(
    (payload: IPostSalesCrmOfferServicePayload) =>
      postSalesCrmOfferService(clientId, offerId, positionId, payload),
    options
  );
